// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { createElement,forwardRef, Ref } from 'react';
import { IconBase, IconProps } from '../icon';

const element = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"path","attrs":{"fill":"props.filledColor","d":"M21.5 2H2.5V22H21.5V2ZM17 7V9H7V7H17ZM17 11V13H7V11H17ZM14 17H7V15H14V17Z"}}]};

const ArticleFilledIcon = forwardRef<SVGElement, IconProps>((props: IconProps, ref: Ref<SVGElement>) => createElement(
  IconBase,
  {
    ...props,
    id: 'article-filled',
    ref,
    icon: element,
  },
));

ArticleFilledIcon.displayName = 'ArticleFilledIcon';

export default ArticleFilledIcon;
